import React, { Fragment } from "react";
import Header from "../components/Header";

import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PageHeader from "../components/PageHeader";
import OurPackagesSection from "../components/OurPackagesSections/OurPackagesSection";





const OurPackages = () => {
  return (
    <Fragment>
      <Header />
      <PageHeader
        bgImg={require("../assets/img/jobsection-1.jpg")}
        title="Packages"
        content=""
      />
  
     <OurPackagesSection />

      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default OurPackages;
